import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import { withTranslation } from "react-i18next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { useState } from "react";
import moment from "moment";
import { getOrganizatioanApi, updateLedgers } from "api";
import { number } from "prop-types";

class PrintLedgerReport extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      totalPcs: 0,
      totalWeight: 0,
      isHiddenTrue: false,
      totalPieces: 0,
      totalAmount: 0,
      organizations: {},
      editRowIndex: -1,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      ledgerDetailStock:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data?.ledgerDetails
          : [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "02",
        categories: "HPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "03",
        categories: "LPHT",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
      {
        id: "04",
        categories: "REAL",
        weight: "1.50 CT",
        pieces: "01",
        rate: "100",
        amount: "150",
      },
    ];
  }

  printIframe = async (e, id) => {
    e.preventDefault();
    const iframe = (await document.frames)
      ? document.frames[id]
      : document.getElementById(id);
    const iframeWindow = iframe.contentWindow || iframe;

    iframe.focus();
    iframeWindow.print();

    return false;
  };

  async update() {
    if (this.state.props.data.printDate == null) {
      const data = await updateLedgers({
        id: this.state.props.data.id,
        printStatus: "Yes",
        printDate: moment().format("YYYY-MM-DD"),
      });
    }
  }

  async componentDidMount() {
    const data = await getOrganizatioanApi();
    if (data && data.data) {
      this.setState({
        organizations: data.data.organizations[0],
      });
    }

    let totalSubWeight = 0;

    this.state.ledgerDetailStock.map(x => {
      if (
        x.mainJangad.jangads.reduce((prev, current) => {
          return prev.cycle < current.cycle ? prev : current;
        }).factory.isInternal != true
      ) {
        totalSubWeight += parseFloat(
          x.mainJangad?.jangads?.reduce((prev, current) => {
            return prev.cycle < current.cycle ? prev : current;
          }).weight
        );
      } else {
        totalSubWeight += parseFloat(
          x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
            (accum, curr) => {
              if (typeof accum == "object") {
                accum = parseFloat(accum.weight);
                accum += parseFloat(curr.weight);
              } else {
                accum += parseFloat(curr.weight);
              }
              return accum;
            }
          )
        );
      }
    });

    let totalSubPieces = 0;

    this.state.ledgerDetailStock.map(x => {
      if (
        x.mainJangad.jangads.reduce((prev, current) => {
          return prev.cycle < current.cycle ? prev : current;
        }).factory.isInternal != true
      ) {
        totalSubPieces += parseInt(
          x.mainJangad?.jangads?.reduce((prev, current) => {
            return prev.cycle < current.cycle ? prev : current;
          }).pieces
        );
      } else {
        totalSubPieces += parseInt(
          x.salesOfficeOutWardStock.graderStock.stockGraderInWards.length
        );
      }
    });

    let totalSubAmount = 0;

    totalSubAmount += parseFloat(
      this.state.ledgerDetailStock.map(x => {
        if (
          x.mainJangad.jangads.reduce((prev, current) => {
            return prev.cycle < current.cycle ? prev : current;
          }).factory.isInternal != true
        ) {
          x.mainJangad.pRate *
            x.mainJangad?.jangads?.reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight;
        } else {
          return (
            x.mainJangad.pRate *
            x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
              (accum, curr) => {
                if (typeof accum == "object") {
                  accum = parseFloat(accum.weight);
                  accum += parseFloat(curr.weight);
                } else {
                  accum += parseFloat(curr.weight);
                }
                return accum;
              }
            )
          );
        }
      })
    );

    this.setState({
      totalWeight: totalSubWeight,
      totalPieces: totalSubPieces,
      totalAmount: totalSubAmount,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  componentDidUpdate() {
    if (this.state.isHiddenTrue == true) {
      setTimeout(() => {
        console.log("dfsf");
        window.print();
      }, 100);
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: `${this.props.t("Total")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
        formatter: (cell, row) => {
          return row.mainJangad.name + "-" + row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        footer: (columnData, column, columnIndex) =>
          columnData.reduce((acc, item) => acc + item, 0),
        formatter: (cell, row) => {
          row.pieces = row.stockDataEntryInWard.pieces;
          return cell;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0) + " CT",
      },

      {
        dataField: "rate",
        text: `${this.props.t("Rate")}`,
        footer: "",
        formatter: (cell, row) => {
          return row.mainJangad.pRate;
        },
      },
      {
        dataField: "amount",
        text: `${this.props.t("Amount")}`,
        footer: columnData => columnData.reduce((acc, item) => acc + item, 0),
        formatter: (cell, row) => {
          row.amount = row.mainJangad.pRate * row.weight;
          return cell;
        },
      },
    ];
    this.jangadColumns = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        footer: (columnData, column, columnIndex) =>
          columnData.reduce((acc, item) => acc + item, 0),
        formatter: (cell, row) => {
          row.pieces = row.jangad.pieces;
          return cell;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0) + " CT",
        formatter: (cell, row) => {
          row.weight = row.jangad.weight;
          return cell;
        },
      },

      {
        dataField: "rate",
        text: `${this.props.t("Rate")}`,
        footer: "",
        formatter: (cell, row) => {
          return row.mainJangad.pRate;
        },
      },
      {
        dataField: "amount",
        text: `${this.props.t("Amount")}`,
        footer: columnData => columnData.reduce((acc, item) => acc + item, 0),
        formatter: (cell, row) => {
          row.amount = row.mainJangad.pRate * row.jangad.weight;
          return cell;
        },
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        footer: "05",
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "7.50 CT",
      },

      {
        dataField: "rate",
        text: `${this.props.t("Rate")}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t("Amount")}`,
        footer: "750",
      },
    ];
    document.title = `Ledger ${moment().format("DD-MM-YYYY")}`;

    let weight = 0;
    let pieces = 0;
    this.state.props.data.ledgerDetails?.map((start, next) => {
      let data = start.mainJangad.jangads.filter(x => x.cycle == 1);
      if (data.length > 0)
        return (pieces += start.mainJangad.jangads.filter(x => x.cycle == 1)[0]
          .pieces);
      else return pieces;
    });
    this.state.props.data.ledgerDetails?.map((start, next) => {
      let data = start.mainJangad.jangads.filter(x => x.cycle == 1);
      if (data.length > 0)
        return (weight += start.mainJangad.jangads.filter(x => x.cycle == 1)[0]
          .weight);
      else return weight;
    });
    return (
      <React.Fragment>
        {[1, 2].map(x => {
          return (
            <>
              <div
                className={`ledgerDetailView border border-2 border-dark mx-1 width-height`}
              >
                {this.state.ledgerDetailStock &&
                Object.keys(this.state.organizations).length > 0 ? (
                  <>
                    <Card>
                      <div>
                        <h2 className="fw-bold pt-2 text-center text-black">
                          P3Y Diamond Tech
                        </h2>
                        <div className="border_dark"></div>
                        <h5 className="text-center pt-1">
                          {this.state.organizations.addressLine1}{" "}
                          {this.state.organizations.addressLine2}
                        </h5>

                        <div className="d-flex px-1 justify-content-between">
                          <div>
                            <h5 className="text-black d-inline fw-bold">
                              {" "}
                              Email:
                            </h5>
                            <p className="d-inline fs-5 ps-2">
                              {this.state.organizations.email}
                            </p>
                          </div>
                          <div>
                            <h5 className="text-black d-inline fw-bold">
                              GSTIN/UIN:
                            </h5>
                            <p className="d-inline fs-5 ps-2">
                              {this.state.organizations.gstNo}
                            </p>
                          </div>
                        </div>

                        <div className="border_dark"></div>
                        <h4 className="fw-bold text-center py-1 text-black">
                          Ledger
                        </h4>
                        <div className="border_dark"></div>

                        <div className="d-sm-flex d-block text-sm-start text-center justify-content-between px-1">
                          <div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                {this.props.t("Party Name")}:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.party.name}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Address:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.party.addressLine1}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                GSTIN/UIN:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.party.gstNo}
                              </p>
                            </div>
                          </div>
                          <div className="ps-1">
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Date:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {moment().format("DD-MM-YYYY")}
                              </p>
                            </div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Time:
                              </h5>{" "}
                              <p className="d-inline fs-5 ps-2">
                                {moment().format("hh:mm:ss A")}
                              </p>
                            </div>
                            <div></div>
                            <div>
                              <h5 className="fw-bold d-inline text-black pt-2">
                                Ledger No:
                              </h5>
                              <p className="d-inline fs-5 ps-2">
                                {this.state.props.data.id}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="text-end pb-0 mb-0 fs-5 col-8">
                            <p className="pb-0 mb-0">
                              {"["}
                              {moment(this.state.props.data.fromDate).format(
                                "DD-MM-YYYY"
                              )}{" "}
                              <span className="fw-bold text-dark">To</span>{" "}
                              {moment(this.state.props.data.toDate).format(
                                "DD-MM-YYYY"
                              )}
                              {"]"}
                            </p>
                          </div>
                          <div className="text-center col-4 ps-3">
                            <p className="pb-0 mb-0 me-5 pe-5 fs-5 fw-bold text-dark">
                              {x == 1 ? "ORIGINAL" : ""}
                            </p>
                          </div>
                        </div>
                        <div className="pt-3 px-3">
                          <div className="table-responsive">
                            <table className="table table-bordered background-light1 text-center">
                              <thead className="fs-5 fw-bold">
                                <tr className="p-0">
                                  <th className="p-0">
                                    {this.props.t("Jangad ID")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Pieces")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Weight Crt")}
                                  </th>
                                  <th className="p-0">
                                    {this.props.t("Category")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="fs-5 foo1">
                                {this.state.ledgerDetailStock
                                  .sort(
                                    (a, b) =>
                                      a.mainJangad.createdAt -
                                      b.mainJangad.createdAt
                                  )
                                  .map(x => {
                                    return (
                                      <tr className="p-0" key={x.id}>
                                        <td className="p-0">
                                          {moment(
                                            x.mainJangad.createdAt
                                          ).format("DD-MM-YYYY")}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.jangads.reduce(
                                            (prev, current) => {
                                              return prev.cycle < current.cycle
                                                ? prev
                                                : current;
                                            }
                                          ).factory.isInternal != true
                                            ? x.mainJangad.jangads.reduce(
                                                (prev, current) => {
                                                  return prev.cycle <
                                                    current.cycle
                                                    ? prev
                                                    : current;
                                                }
                                              ).pieces
                                            : x.salesOfficeOutWardStock
                                                .graderStock.stockGraderInWards
                                                .length}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.jangads.reduce(
                                            (prev, current) => {
                                              return prev.cycle < current.cycle
                                                ? prev
                                                : current;
                                            }
                                          ).factory.isInternal != true
                                            ? x.mainJangad.jangads.reduce(
                                                (prev, current) => {
                                                  return prev.cycle <
                                                    current.cycle
                                                    ? prev
                                                    : current;
                                                }
                                              ).weight
                                            : x.salesOfficeOutWardStock.graderStock.stockGraderInWards.reduce(
                                                (accum, curr) => {
                                                  if (
                                                    typeof accum == "object"
                                                  ) {
                                                    accum = parseFloat(
                                                      accum.weight
                                                    );
                                                    accum += parseFloat(
                                                      curr.weight
                                                    );
                                                  } else {
                                                    accum += parseFloat(
                                                      curr.weight
                                                    );
                                                  }
                                                  return accum;
                                                }
                                              )}
                                        </td>
                                        <td className="p-0">
                                          {x.mainJangad.category.name}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                              <tfoot>
                                <tr className="fs-5 p-0 fw-bold">
                                  <th className="p-0">
                                    {this.props.t("Total")}
                                  </th>
                                  <th className="p-0">
                                    {this.state.totalPieces}
                                  </th>
                                  <th className="p-0">
                                    {this.state.totalWeight}
                                  </th>
                                  <th className="p-0"></th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        <div className="px-3">
                          <h4 className="fw-bold text-black pt-2">
                            Terms and Conditions
                          </h4>
                          {this.state.organizations.tac
                            .split("(")
                            .map((x, index) => {
                              if (x == "") {
                                return null;
                              } else {
                                return (
                                  <p
                                    key={index}
                                    className="fs-5 text-black pb-0 mb-0"
                                  >
                                    {" "}
                                    {x}{" "}
                                  </p>
                                );
                              }
                            })}
                          <h4 className="fw-bold text-black pt-2">
                            Declaration
                          </h4>
                          {this.state.organizations.declaration
                            .split("(")
                            .map((x, index) => {
                              if (x == "") {
                                return null;
                              } else {
                                return (
                                  <p
                                    key={index}
                                    className="fs-5 text-black pb-0 mb-0"
                                  >
                                    {" "}
                                    {x}{" "}
                                  </p>
                                );
                              }
                            })}
                          <div className="d-sm-flex d-block justify-content-between pt-1 pb-4">
                            <div>
                              <h5>
                                For <strong> Receiver:</strong>
                              </h5>
                            </div>
                            <div>
                              <h5>
                                for
                                <strong> P3Y Diamond Tech</strong>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          );
        })}

        <div className="ledgerPrintView page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("REPORTS")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{}}
                validationSchema={Yup.object().shape({})}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("View Ledger report")}
                            </h4>
                          </div>
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="ledgerID"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Ledger Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.ledgerID && touched.ledgerID
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.props.data.id}
                                    readOnly={true}
                                    type="text"
                                    name="ledgerID"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="ledgerID"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Party Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.props.data.party.name}
                                    readOnly={true}
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="totalPcs"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total No of Pieces")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.totalPcs && touched.totalPcs
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={pieces}
                                    type="text"
                                    name="totalPcs"
                                    placeholder="30"
                                  />
                                  <ErrorMessage
                                    name="totalPcs"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={weight}
                                    readOnly={number}
                                    type="text"
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                        <div className="col-xl-4 col-12 pt-3 no-print">
                          <div className="px-4">
                            <div className="row border-gray py-3">
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Contact Person")} :</h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>
                                  {
                                    this.state.props.data.party
                                      .contactPersonName
                                  }
                                </h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.1")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>{this.state.props.data.party.mobileNo1}</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.2")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>{this.state.props.data.party.mobileNo2}</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Email Address")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>{this.state.props.data.party.email}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {Array.isArray(this.state.ledgerDetailStock) &&
                        this.state.ledgerDetailStock.map(x => {
                          return (
                            <div key={x.id + "1"} className="row px-3 pt-3">
                              <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                                <div>
                                  <h4 className="fw-bold pb-3 text-black">
                                    1.{this.props.t("Jangad Id")} -{" "}
                                    {x.mainJangad.name}
                                  </h4>
                                </div>
                                <div>
                                  <div className="pt-3 pt-xxl-0">
                                    <h4 className="d-inline text-black fw-bold pe-3">
                                      {this.props.t("To Date")} :{" "}
                                      {moment(x.mainJangad.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </h4>
                                    <h4 className="d-inline text-black fw-bold">
                                      {this.props.t("To Date")}:{" "}
                                      {moment(
                                        x.salesOfficeOutWardStock.createdAt
                                      ).format("DD/MM/YYYY")}
                                    </h4>
                                  </div>
                                </div>
                                <div className="pt-3 pt-xxl-0">
                                  <h4 className="fw-bold pb-3 text-black">
                                    {this.props.t("Category Name")} -{" "}
                                    {x.mainJangad.category.name}
                                  </h4>
                                </div>
                              </div>
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField="id"
                                  classes="foo"
                                  headerClasses="background-light fs-5"
                                  footerClasses="background-light fs-5"
                                  bootstrap4={true}
                                  data={
                                    x.salesOfficeOutWardStock != null &&
                                    x.salesOfficeOutWardStock.graderStock !=
                                      null
                                      ? x.salesOfficeOutWardStock.graderStock
                                          .stockGraderInWards
                                      : [x.salesOfficeOutWardStock]
                                  }
                                  columns={
                                    x.salesOfficeOutWardStock != null &&
                                    x.salesOfficeOutWardStock.graderStock !=
                                      null
                                      ? this.columns1
                                      : this.jangadColumns
                                  }
                                />
                              </div>
                            </div>
                          );
                        })}
                      <div className="mb-3 row px-3 pt-3 no-print">
                        <Label
                          htmlFor="notes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Ledger Notes")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.notes && touched.notes
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            value={this.state.props.data.notes}
                            type="text"
                            name="notes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="notes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <div className="btn-group">
                          <Button
                            type="button"
                            className="py-2 px-2 border-0 bg-success rounded me-3"
                            onClick={() => {
                              window.print();
                              // this.setState({
                              //   isHiddenTrue: true,
                              // });
                            }}
                          >
                            <img
                              src="images/dashboard-images/printwhite.svg"
                              className="text-white"
                              alt="print"
                            />
                          </Button>
                          <Button
                            color="primary"
                            className="fs-4 px-5 no-print"
                            type="submit"
                            onClick={() => this.update()}
                          >
                            Print
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(PrintLedgerReport);
